import { styled } from "@health-zelas/delta"

export const ProgressBar = styled('div', {
  height: '72px',
  padding: '16px',
  borderRadius: '$buttonBorderRadius',
  fontSize: '$xxxxs',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.08)',
  color: '$neutralDark',
  backgroundColor: '$neutralUltralight',
  marginBottom: '$xs'
})

export const Top = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '6px'
})

export const Cells = styled('div', {
  display: 'flex',
  justifyContent: 'space-between'
})

export const Cell = styled('div', {
  width: '25%',
  height: '16px',
  marginRight: '8px',
  borderRadius: '500px',
  '&:last-child': {
    marginRight: '0'
  }
})

export const Current = styled('span', {
  fontSize: '$xxxs',
  fontWeight: '$bold',
  marginRight: '4px',
  position: 'relative',
  top: '2px'
})
